export default __webpack_public_path__ + "static/media/mikechen.66da4c00.gif";